import React from 'react';
import { Button, Modal, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';


const DeleteConfirmDialog = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  return (
    <>
        <Modal show={props.show} centered >
          <Modal.Body style={{backgroundColor: '#E8E8E8', borderRadius: '7px'}} >
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
              <div>
                {props.title}
              </div>
              <div style={{marginTop:'5px', fontStyle:'italic', wordWrap: 'break-word'}}>
                {props.targetName ? props.targetName : ''}
              </div>

              <form>
                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {props.errMsgDeleteConfirm}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }}
                      onClick={props.onCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft: '15px' }}
                      onClick={props.onSubmit}>
                      {t("I18N_Yes")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>
    </>
  );
}

export default DeleteConfirmDialog;
